import {CountryPackageBundleBs5} from "./country_package_bundle.js";

const CountryPackageBundles = (props) => {
    let productPackage = props.productPackage;
    let renderPackageBundle = productPackage.hasOwnProperty("bundles") &&
        productPackage.bundles.length > 0 ?
        productPackage.bundles.map((bundle, index) => {
            let hasLimit = productPackage.limits.hasOwnProperty("addons") && productPackage.limits.addons.hasOwnProperty(bundle.key)
                ? productPackage.limits.addons[bundle.key] : null;
            return <CountryPackageBundleBs5 packageBundle={bundle}
                                            hasLimit={hasLimit}
                                            key={index}
                                            {...props} />
        }) : null;
    return (
        <React.Fragment>
            {renderPackageBundle}
        </React.Fragment>
    )
}

export default CountryPackageBundles;
